import { render, staticRenderFns } from "./Eleccion.vue?vue&type=template&id=a6c736a0&scoped=true"
import script from "./Eleccion.vue?vue&type=script&lang=ts"
export * from "./Eleccion.vue?vue&type=script&lang=ts"
import style0 from "./Eleccion.vue?vue&type=style&index=0&id=a6c736a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c736a0",
  null
  
)

export default component.exports